export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0168_FC1_0001.158b36d2.jpg";